import { defineComponent, h } from 'vue';
import { VAvatar, VCol, VListSubheader, VRow } from 'vuetify/components';
import { VListItemAction, VListItemMedia } from 'vuetify/components/VList';

export function registerLegacyVuetifyCompat(app) {
    app.component(
        'v-list-item-content',
        defineComponent({
            name: 'LegacyVListItemContent',
            inheritAttrs: false,
            setup(_, { attrs, slots }) {
                return () =>
                    h(
                        'div',
                        {
                            ...attrs,
                            class: [
                                'v-list-item__content',
                                'v-list-item-content',
                                attrs.class
                            ]
                        },
                        slots.default ? slots.default() : []
                    );
            }
        })
    );

    app.component(
        'v-list-item-icon',
        defineComponent({
            name: 'LegacyVListItemIcon',
            inheritAttrs: false,
            setup(_, { attrs, slots }) {
                return () =>
                    h(
                        VListItemAction,
                        {
                            ...attrs,
                            start: true,
                            class: ['v-list-item-icon', attrs.class]
                        },
                        slots
                    );
            }
        })
    );

    app.component(
        'v-list-item-action',
        defineComponent({
            name: 'LegacyVListItemAction',
            inheritAttrs: false,
            setup(_, { attrs, slots }) {
                return () =>
                    h(
                        VListItemAction,
                        {
                            ...attrs,
                            start: true,
                            class: ['v-list-item-action', attrs.class]
                        },
                        slots
                    );
            }
        })
    );

    app.component(
        'v-list-item-avatar',
        defineComponent({
            name: 'LegacyVListItemAvatar',
            inheritAttrs: false,
            setup(_, { attrs, slots }) {
                return () =>
                    h(
                        VListItemMedia,
                        {
                            start: true,
                            class: ['v-list-item-avatar', attrs.class]
                        },
                        {
                            default: () => h(VAvatar, attrs, slots)
                        }
                    );
            }
        })
    );

    app.component('v-subheader', VListSubheader);

    app.component(
        'v-flex',
        defineComponent({
            name: 'LegacyVFlex',
            inheritAttrs: false,
            setup(_, { attrs, slots }) {
                return () => {
                    const rest = { ...attrs };
                    const flexProps = {};
                    ['xs', 'sm', 'md', 'lg', 'xl'].forEach(bp => {
                        if (bp in rest && rest[bp] !== false) {
                            flexProps[bp] = true;
                            delete rest[bp];
                        }
                    });
                    Object.keys(rest).forEach(key => {
                        const match = key.match(/^(xs|sm|md|lg|xl)(\d{1,2})$/);
                        if (!match) {
                            return;
                        }
                        const [, bp, size] = match;
                        if (bp === 'xs') {
                            flexProps.cols = Number(size);
                        } else {
                            flexProps[bp] = Number(size);
                        }
                        delete rest[key];
                    });

                    return h(VCol, { ...rest, ...flexProps }, slots);
                };
            }
        })
    );

    app.component(
        'v-layout',
        defineComponent({
            name: 'LegacyVLayout',
            inheritAttrs: false,
            setup(_, { attrs, slots }) {
                return () => {
                    const rest = { ...attrs };
                    const layoutClasses = [];

                    if ('column' in rest && rest.column !== false) {
                        layoutClasses.push('d-flex', 'flex-column');
                        delete rest.column;
                    }
                    if ('wrap' in rest && rest.wrap !== false) {
                        layoutClasses.push('flex-wrap');
                        delete rest.wrap;
                    }
                    if ('align-center' in rest && rest['align-center'] !== false) {
                        layoutClasses.push('align-center');
                        delete rest['align-center'];
                    }
                    if ('justify-center' in rest && rest['justify-center'] !== false) {
                        layoutClasses.push('justify-center');
                        delete rest['justify-center'];
                    }
                    if (
                        'justify-space-between' in rest &&
                        rest['justify-space-between'] !== false
                    ) {
                        layoutClasses.push('justify-space-between');
                        delete rest['justify-space-between'];
                    }
                    if ('align-end' in rest && rest['align-end'] !== false) {
                        layoutClasses.push('align-end');
                        delete rest['align-end'];
                    }
                    if ('row' in rest) {
                        delete rest.row;
                    }

                    return h(
                        VRow,
                        { ...rest, class: [attrs.class, ...layoutClasses] },
                        slots
                    );
                };
            }
        })
    );
}
